module.exports = __webpack_public_path__ + "img/Group 3726.3ad53b14.png";